<!-- eslint-disable max-len -->
<template>
    <div>
        <PageHeader>
            {{ $t('yourTipboxLink') }}
            <template #subtitle>
                <div>{{ $t('createYourTipboxLinkProfileWithASimpleConfigurator') }}</div>
            </template>
            <template #bottom>
                <div class="d-flex gap-3">
                    <ButtonIcon
                        icon="file-text"
                        :icon-size="24"
                        variant="link"
                        class="p-0 d-flex align-items-center"
                        @click="openHelp"
                    >
                        {{ $t('takeALookAtHelp') }}
                    </ButtonIcon>
                </div>
            </template>
        </PageHeader>

        <DataTable
            :header="$t('selectSpace')"
            :items="items"
            :fields="fields"
            :loading="loading"
            :pagination="false"
            stacked="md"
            sort-by="id"
            sort-direction="asc"
        >
            <template #cell(slug)="{ item }">
                <a v-if="item.landingPage" :href="`${previewUrl}/${item.landingPage.slug}`" target="_blank"> tipbox.pl/{{ item.landingPage.slug }} </a>
            </template>
            <template #cell(actions)="{ item }">
                <ButtonIcon v-if="item.landingPage" :to="{ name: 'WidgeterTipboxLinkEdit', params: { id: item.space.id } }" class="wide" size="sm">
                    {{ $t('widgetSettings.editSettings') }}
                </ButtonIcon>
                <ButtonIcon v-else variant="success" :to="{ name: 'WidgeterTipboxLinkEdit', params: { id: item.space.id } }" class="wide" size="sm">
                    {{ $t('widgetSettings.createSettings') }}
                </ButtonIcon>
            </template>
        </DataTable>
    </div>
</template>

<script>
    import DataTable from '@/components/common/DataTable.vue';

    export default {
        name: 'TipboxLandingSettings',
        components: {
            DataTable,
        },
        data() {
            return {
                requestTipboxLandingPages: this.$req('tipbox/TipboxLandingPages'),
            };
        },
        computed: {
            previewUrl() {
                return process.env.VUE_APP_TIPBOX_LANDING_PREVIEW_URL.replace(/\/+$/, '');
            },
            fields() {
                return [
                    {
                        key: 'space.name',
                        label: this.$t('yourPage'),
                    },
                    {
                        key: 'slug',
                        label: this.$t('profileAddress'),
                        slot: 'slug',
                    },
                    {
                        key: 'actions',
                        label: '',
                        tdClass: 'text-right',
                        thClass: 'text-right',
                    },
                ];
            },
            items() {
                return this.requestTipboxLandingPages.getData() || [];
            },
            loading() {
                return this.requestTipboxLandingPages.getLoading();
            },
        },
        methods: {
            openHelp() {
                window.Gleap.openHelpCenterArticle('14', false);
            },
            fetchTipboxLandingPages() {
                const user = this.$store.getters['auth/getUser'];
                return this.requestTipboxLandingPages.get({ urlParams: { userId: user.id }, requestParams: { statuses: '1,2' } }).catch(error => this.$toastr.error(error.message, this.$t('errorOccurred')));
            },
        },
        created() {
            this.fetchTipboxLandingPages();
        },
    };
</script>
